<div class="contact-page container-fluid py-4 py-md-5 px-3 px-md-4">
    <!-- Hero Banner Header -->
    <div class="contact-hero text-center mb-5 p-4 p-md-5 rounded-4 shadow-sm">
        <div class="contact-hero__badge mb-3">
            <span class="material-symbols-outlined align-middle me-1 fs-5">support_agent</span>
            We're Here To Help You
        </div>
        <h1 class="display-5 fw-bold mb-3 contact-hero__title">
            Get In Touch With {{ tenantConfigService.settings?.Name || 'Our Team' }}
        </h1>
        <p class="lead text-muted mx-auto mb-0" style="max-width: 680px;">
            Have questions about document authentication, apostille processing, or order status? 
            Our dedicated team of specialists is ready to assist you.
        </p>
    </div>

    <!-- Contact Details Cards Grid -->
    <div class="row g-4 mb-5">
        <!-- Contact Email Card -->
        <div class="col-12 col-md-4">
            <div class="contact-card h-100 p-4 rounded-4 shadow-sm border-0 d-flex flex-column">
                <div class="contact-card__icon-wrapper mb-3 text-primary">
                    <span class="material-symbols-outlined fs-2">mail</span>
                </div>
                <h3 class="h5 fw-bold mb-2">Email Support</h3>
                <p class="text-muted small mb-3">Send us an email anytime and our team will get back to you within 24 hours.</p>
                <div class="mt-auto">
                    @if (tenantConfigService.settings?.contact_email) {
                        <a [href]="'mailto:' + tenantConfigService.settings?.contact_email" class="contact-card__link text-decoration-none fw-semibold fs-6 text-break">
                            {{ tenantConfigService.settings?.contact_email }}
                        </a>
                    } @else {
                        <a href="mailto:support@legalizationus.com" class="contact-card__link text-decoration-none fw-semibold fs-6 text-break">
                            support@legalizationus.com
                        </a>
                    }
                </div>
            </div>
        </div>

        <!-- Contact Phone Card -->
        <div class="col-12 col-md-4">
            <div class="contact-card h-100 p-4 rounded-4 shadow-sm border-0 d-flex flex-column">
                <div class="contact-card__icon-wrapper mb-3 text-success">
                    <span class="material-symbols-outlined fs-2">call</span>
                </div>
                <h3 class="h5 fw-bold mb-2">Call Us Directly</h3>
                <p class="text-muted small mb-3">Speak directly with an apostille specialist Monday through Friday, 9:00 AM – 5:00 PM EST.</p>
                <div class="mt-auto">
                    @if (tenantConfigService.settings?.contact_phone) {
                        <a [href]="'tel:' + tenantConfigService.settings?.contact_phone" class="contact-card__link text-decoration-none fw-semibold fs-6">
                            {{ tenantConfigService.settings?.contact_phone }}
                        </a>
                    } @else {
                        <a href="tel:+18003461604" class="contact-card__link text-decoration-none fw-semibold fs-6">
                            +1 (800) 346-1604
                        </a>
                    }
                </div>
            </div>
        </div>

        <!-- Contact Address Card -->
        <div class="col-12 col-md-4">
            <div class="contact-card h-100 p-4 rounded-4 shadow-sm border-0 d-flex flex-column">
                <div class="contact-card__icon-wrapper mb-3 text-danger">
                    <span class="material-symbols-outlined fs-2">location_on</span>
                </div>
                <h3 class="h5 fw-bold mb-2">Main Office Address</h3>
                <p class="text-muted small mb-3">Our headquarters location for document drop-offs, mailings, and inquiries.</p>
                <div class="mt-auto">
                    @if (tenantConfigService.settings?.contact_address) {
                        <address class="contact-card__address mb-0 fw-semibold fs-6 not-italic">
                            {{ tenantConfigService.settings?.contact_address }}
                        </address>
                    } @else {
                        <address class="contact-card__address mb-0 fw-semibold fs-6 not-italic">
                            1000 Connecticut Ave NW, Suite 900, Washington, DC 20036
                        </address>
                    }
                </div>
            </div>
        </div>
    </div>

    <!-- Secondary Information Section: Business Hours & Expedited Service -->
    <div class="row g-4 justify-content-center">
        <!-- Hours Card -->
        <div class="col-12 col-md-6">
            <div class="hours-card p-4 p-md-5 rounded-4 shadow-sm border-0 bg-white h-100">
                <div class="d-flex align-items-center gap-3 mb-3">
                    <div class="hours-card__icon text-warning">
                        <span class="material-symbols-outlined fs-2">schedule</span>
                    </div>
                    <div>
                        <h3 class="h5 fw-bold mb-0">Business Hours</h3>
                        <span class="small text-muted">EST Time Zone</span>
                    </div>
                </div>
                <ul class="list-unstyled mb-0 border-top pt-3">
                    <li class="d-flex justify-content-between py-2 border-bottom">
                        <span class="fw-medium text-muted">Monday – Friday:</span>
                        <span class="fw-semibold">9:00 AM – 5:00 PM</span>
                    </li>
                    <li class="d-flex justify-content-between py-2 border-bottom">
                        <span class="fw-medium text-muted">Saturday:</span>
                        <span class="fw-semibold text-secondary">By Appointment</span>
                    </li>
                    <li class="d-flex justify-content-between py-2">
                        <span class="fw-medium text-muted">Sunday:</span>
                        <span class="fw-semibold text-danger">Closed</span>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Express Processing Info Box -->
        <div class="col-12 col-md-6">
            <div class="info-card p-4 p-md-5 rounded-4 shadow-sm border-0 text-white h-100 d-flex flex-column justify-content-center">
                <div class="d-flex align-items-start gap-3">
                    <span class="material-symbols-outlined fs-1 text-warning">verified</span>
                    <div>
                        <h4 class="h5 fw-bold mb-2">Need Urgent Processing?</h4>
                        <p class="small mb-4 opacity-90">
                            We offer expedited state & federal apostille services with rapid turnaround times. Contact us directly by phone or email for urgent processing.
                        </p>
                        <a routerLink="/select-state" class="btn btn-light btn-md fw-semibold text-primary rounded-3 shadow-sm">
                            Select Your State
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
